<template>
	<transition
			appear
			:appear-active-class="$_stpLyt_stylePageLayoutAnimation()">
		<v-row	id="_stpLyt_top"
				class="customVRow">
			<v-col>
				<v-stepper
						v-model="stepNumber_"
						class="stepper_"
						:dark="$_stpLyt_styleStepperDark"
						:light="$_stpLyt_styleStepperLight"
						:vertical="$_stpLyt_stateAppIsMobileScreen">
					<!-- stepper header ( only for web ) -->
					<template v-if="!$_stpLyt_stateAppIsMobileScreen">
						<v-row>
							<v-col>
								<v-card class="customVCard"
										:color="$_stpLyt_styleStepperCardColor"
										:dark="$_stpLyt_styleStepperCardDark"
										:elevation="$_stpLyt_styleStepperCardElevation"
										:flat="$_stpLyt_styleStepperCardFlat"
										:hover="$_stpLyt_styleStepperCardHover"
										:light="$_stpLyt_styleStepperCardLight"
										:outlined="$_stpLyt_styleStepperCardOutlined"
										:raised="$_stpLyt_styleStepperCardRaised"
										:tile="$_stpLyt_styleStepperCardTile">
									<v-stepper-header class="stepperHeader_">
										<v-row>
											<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
												<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
													<v-col :key="contentKey">
														<v-card class="customVCard"
																:color="$_stpLyt_styleStepperHeaderCardColor"
																:dark="$_stpLyt_styleStepperHeaderCardDark"
																:elevation="$_stpLyt_styleStepperHeaderCardElevation"
																:flat="$_stpLyt_styleStepperHeaderCardFlat"
																:hover="$_stpLyt_styleStepperHeaderCardHover"
																:light="$_stpLyt_styleStepperHeaderCardLight"
																:outlined="$_stpLyt_styleStepperHeaderCardOutlined"
																:raised="$_stpLyt_styleStepperHeaderCardRaised"
																:tile="$_stpLyt_styleStepperHeaderCardTile">
															<v-stepper-step 
																	class="stepperStep_"
																	:color="$_stpLyt_styleStepperStepColor"
																	:complete="completed_[contentVals.stepNumber]"
																	:step="contentVals.stepNumber">
																<span v-html="$_stpLyt_langContentTitle(contentVals)" />
															</v-stepper-step>
														</v-card>
													</v-col>
												</template>
											</template>
										</v-row>
									</v-stepper-header>
								</v-card>
							</v-col>
						</v-row>
					</template>
					<!-- stepper body -->
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
							<v-stepper-items
									:key="contentKey"
									class="stepperItem_">
								<!-- stepper body - step head (only for mobile) -->
								<template v-if="$_stpLyt_stateAppIsMobileScreen">
									<v-row>
										<v-col>
											<v-card class="customVCard"
													:color="$_stpLyt_styleStepperCardColor"
													:dark="$_stpLyt_styleStepperCardDark"
													:elevation="$_stpLyt_styleStepperCardElevation"
													:flat="$_stpLyt_styleStepperCardFlat"
													:hover="$_stpLyt_styleStepperCardHover"
													:light="$_stpLyt_styleStepperCardLight"
													:outlined="$_stpLyt_styleStepperCardOutlined"
													:raised="$_stpLyt_styleStepperCardRaised"
													:tile="$_stpLyt_styleStepperCardTile">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_stpLyt_styleStepperHeaderCardColor"
																:dark="$_stpLyt_styleStepperHeaderCardDark"
																:elevation="$_stpLyt_styleStepperHeaderCardElevation"
																:flat="$_stpLyt_styleStepperHeaderCardFlat"
																:hover="$_stpLyt_styleStepperHeaderCardHover"
																:light="$_stpLyt_styleStepperHeaderCardLight"
																:outlined="$_stpLyt_styleStepperHeaderCardOutlined"
																:raised="$_stpLyt_styleStepperHeaderCardRaised"
																:tile="$_stpLyt_styleStepperHeaderCardTile">
															<v-stepper-step
																	class="stepperStep_"
																	:complete="completed_[contentVals.stepNumber]"
																	:step="contentVals.stepNumber">
																<span v-html="$_stpLyt_langContentTitle(contentVals)" />
															</v-stepper-step>
														</v-card>
													</v-col>
												</v-row>
											</v-card>
										</v-col>
									</v-row>
								</template>
								<!-- stepper body - step body -->
								<v-stepper-content
										class="stepperContent_"
										:step="contentVals.stepNumber">
									<v-row>
										<v-col>
											<v-card class="customVCard"
													:color="$_stpLyt_styleStepperBodyCardColor"
													:dark="$_stpLyt_styleStepperBodyCardDark"
													:elevation="$_stpLyt_styleStepperBodyCardElevation"
													:flat="$_stpLyt_styleStepperBodyCardFlat"
													:hover="$_stpLyt_styleStepperBodyCardHover"
													:light="$_stpLyt_styleStepperBodyCardLight"
													:outlined="$_stpLyt_styleStepperBodyCardOutlined"
													:raised="$_stpLyt_styleStepperBodyCardRaised"
													:tile="$_stpLyt_styleStepperBodyCardTile">
												<v-row>
													<template v-if="contentVals.image">
														<v-col xs="12" md="6">
															<v-img	class="customVImg cardImage_"
																	cover 
																	:src="$_stpLyt_styleContentImageUrl(contentVals)" />
														</v-col>
													</template>
													<v-col xs="12" md="6">
														<v-row no-gutters>
															<v-col>
																<template v-if="contentVals.subTitle">
																	<v-row no-gutters>
																		<v-col>
																			<v-card-title>
																				<span v-html="$_stpLyt_langContentSubTitle(contentVals)" />
																			</v-card-title>
																		</v-col>
																	</v-row>
																</template>
																<template v-if="!isFalse($_stpLyt_langContentText(contentVals))">
																	<v-row gutters>
																		<v-col>
																			<v-card-text>
																				<span	class="markdown"
																						v-html="marked($_stpLyt_langContentText(contentVals))" />
																			</v-card-text>
																		</v-col>
																	</v-row>
																</template>
															</v-col>
														</v-row>
														<v-row no-gutters>
															<v-col>
																<v-card-actions>
																	<v-row dense>
																		<template v-if="contentVals.actionButtons">
																			<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																				<template v-if="!$_stpLyt_isPreSetButton(actionButtonKey)">
																					<v-col :key="actionButtonKey" cols="auto">
																						<v-btn	class="customVBtn"
																								:block="$_stpLyt_styleActionButtonBlock"
																								:color="$_stpLyt_styleActionButtonColor"
																								:dark="$_stpLyt_styleActionButtonDark"
																								:depressed="$_stpLyt_styleActionButtonDepressed"
																								:elevation="$_stpLyt_styleActionButtonElevation"
																								:large="$_stpLyt_styleActionButtonLarge"
																								:light="$_stpLyt_styleActionButtonLight"
																								:outlined="$_stpLyt_styleActionButtonOutlined"
																								:rounded="$_stpLyt_styleActionButtonRounded"
																								:small="$_stpLyt_styleActionButtonSmall"
																								:text="$_stpLyt_styleActionButtonFlat"
																								@click="openLink(actionButtonVals.link)"
																								v-text="$_stpLyt_langActionButtonTitle(actionButtonVals)" />
																					</v-col>
																				</template>
																			</template>
																		</template>
																	</v-row>
																</v-card-actions>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-card>
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<v-card-actions>
													<v-row	align="center"
															justify="center">
														<!-- back button -->
														<template v-if="contentVals.previousStepNumber">
															<v-col cols="auto">
																<v-btn	class="customVBtn"
																		:block="$_stpLyt_styleStepperActionButtonBlock"
																		:color="$_stpLyt_styleStepperActionButtonColor('backStep')"
																		:dark="$_stpLyt_styleStepperActionButtonDark"
																		:depressed="$_stpLyt_styleStepperActionButtonDepressed"
																		:elevation="$_stpLyt_styleStepperActionButtonElevation"
																		:large="$_stpLyt_styleStepperActionButtonLarge"
																		:light="$_stpLyt_styleStepperActionButtonLight"
																		:outlined="$_stpLyt_styleStepperActionButtonOutlined"
																		:rounded="$_stpLyt_styleStepperActionButtonRounded"
																		:small="$_stpLyt_styleStepperActionButtonSmall"
																		:text="$_stpLyt_styleStepperActionButtonFlat"
																		@click="$_stpLyt_back(contentVals)"
																		v-text="$_stpLyt_langBackButton" />
															</v-col>
														</template>
														<!-- next button -->
														<template v-if="contentVals.nextStepNumber">
															<v-col cols="auto">
																<v-btn	class="customVBtn"
																		:block="$_stpLyt_styleStepperActionButtonBlock"
																		:color="$_stpLyt_styleStepperActionButtonColor('nextStep')"
																		:dark="$_stpLyt_styleStepperActionButtonDark"
																		:depressed="$_stpLyt_styleStepperActionButtonDepressed"
																		:elevation="$_stpLyt_styleStepperActionButtonElevation"
																		:large="$_stpLyt_styleStepperActionButtonLarge"
																		:light="$_stpLyt_styleStepperActionButtonLight"
																		:outlined="$_stpLyt_styleStepperActionButtonOutlined"
																		:rounded="$_stpLyt_styleStepperActionButtonRounded"
																		:small="$_stpLyt_styleStepperActionButtonSmall"
																		:text="$_stpLyt_styleStepperActionButtonFlat"
																		@click="$_stpLyt_next(contentVals)"
																		v-text="$_stpLyt_langNextButton" />
															</v-col>
														</template>
														<!-- finish button -->
														<template v-if="contentVals.isLastStep">
															<v-col cols="auto">
																<v-btn	class="customVBtn"
																		:block="$_stpLyt_styleStepperActionButtonBlock"
																		:color="$_stpLyt_styleStepperActionButtonColor('finish')"
																		:dark="$_stpLyt_styleStepperActionButtonDark"
																		:depressed="$_stpLyt_styleStepperActionButtonDepressed"
																		:elevation="$_stpLyt_styleStepperActionButtonElevation"
																		:large="$_stpLyt_styleStepperActionButtonLarge"
																		:light="$_stpLyt_styleStepperActionButtonLight"
																		:outlined="$_stpLyt_styleStepperActionButtonOutlined"
																		:rounded="$_stpLyt_styleStepperActionButtonRounded"
																		:small="$_stpLyt_styleStepperActionButtonSmall"
																		:text="$_stpLyt_styleStepperActionButtonFlat"
																		@click="openLink($_stpLyt_linkFinishButton)"
																		v-text="$_stpLyt_langFinishButton" />
															</v-col>
														</template>
													</v-row>
												</v-card-actions>
											</v-card>
										</v-col>
									</v-row>
								</v-stepper-content>
							</v-stepper-items>
						</template>
					</template>
				</v-stepper>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'StepperLayout',
		props: {
			inits: Object,
			contents: Object
		},
		data() {
			return {
				stepNumber_: 1,

				completed_: {}
			}
		},
		computed: {
			// state
			$_stpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang
			$_stpLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_stpLyt_langNextButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'nextButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_stpLyt_langFinishButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_stpLyt_langFinishTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_stpLyt_langFinishText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_stpLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_stpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_stpLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_stpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_stpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// link
			$_stpLyt_linkFinishButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'finishButton')
			},
			// style
			$_stpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_stpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_stpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_stpLyt_styleStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepper')
			},
			$_stpLyt_styleStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_stpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_stpLyt_styleStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_stpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_stpLyt_styleStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_stpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_stpLyt_styleStepperCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperCard')
			},
			$_stpLyt_styleStepperCardColor() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_stpLyt_styleStepperCardDark() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_stpLyt_styleStepperCardElevation() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_stpLyt_styleStepperCardFlat() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_stpLyt_styleStepperCardHover() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_stpLyt_styleStepperCardLight() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_stpLyt_styleStepperCardOutlined() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_stpLyt_styleStepperCardRaised() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_stpLyt_styleStepperCardTile() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_stpLyt_styleStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperHeaderCard')
			},
			$_stpLyt_styleStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_stpLyt_styleStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_stpLyt_styleStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_stpLyt_styleStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_stpLyt_styleStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_stpLyt_styleStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_stpLyt_styleStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_stpLyt_styleStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_stpLyt_styleStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_stpLyt_styleStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperBodyCard')
			},
			$_stpLyt_styleStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_stpLyt_styleStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_stpLyt_styleStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_stpLyt_styleStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_stpLyt_styleStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_stpLyt_styleStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_stpLyt_styleStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_stpLyt_styleStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_stpLyt_styleStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_stpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_stpLyt_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperActionButton')
			},
			$_stpLyt_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_stpLyt_styleStepperActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return key => {
					if(self_.isObject(actionButton_.color)) {
						return	self_.getStylesVal(actionButton_.color[key]) ||
								self_.getStylesVal(actionButton_.color.default)
					} else {
						return self_.getStylesVal(actionButton_.color)
					}
				}
			},
			$_stpLyt_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_stpLyt_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_stpLyt_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_stpLyt_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_stpLyt_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_stpLyt_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_stpLyt_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_stpLyt_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_stpLyt_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_stpLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_stpLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_stpLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_stpLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_stpLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_stpLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_stpLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_stpLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_stpLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_stpLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_stpLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_stpLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_stpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_stpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_stpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_stpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		created() {
			const self_ = this;
			
			// first step
			const first_ = self_.$_stpLyt_setFirstStep()
			if(!self_.isFalse(first_)) { self_.stepNumber_ = first_ }
		},
		methods: {
			$_stpLyt_setFirstStep() {
				const self_ = this;

				if(self_.isFalse(self_.contents)) { return null }

				let step_;

				Object.keys(self_.contents).forEach(key => {
					if(!step_) { step_ = self_.contents[key].stepNumber }

					if(self_.contents[key].isFirstStep) { step_ = self_.contents[key].stepNumber }
				})

				return step_
			},
			$_stpLyt_isPreSetButton(actionButtonKey) {
				const result_ = actionButtonKey == 'back' ||
								actionButtonKey == 'next' ||
								actionButtonKey == 'finish' ||
								actionButtonKey == 'ok';
				return result_
			},
			$_stpLyt_next(contentVals) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.completed_[contentVals.stepNumber] = true;
					self_.stepNumber_ = contentVals.nextStepNumber;
					return
				}).then(() => {
					vuetify_.goTo('#_stpLyt_top')
				})
			},
			$_stpLyt_back(contentVals) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.completed_[contentVals.previousStepNumber] = false;
					self_.stepNumber_ = contentVals.previousStepNumber;
				}).then(() => {
					vuetify_.goTo('#_stpLyt_top')
				})
			}
		}
	}
</script>

<style scoped>
	.stepper_ {
		box-shadow: none;
		background-color: transparent;
	}
	.stepperHeader_ {
		background-color: transparent;
		box-shadow: none;
		height: 80px;
	}
	.stepperItem_ {
		background-color: transparent;
		box-shadow: none;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>
